import { usePermissionsLoaded } from '@context'
import { useEffect, useRef } from 'react'
import { useQueryParam } from './useQueryParam'

/**
 * Opens a create form from `?create=1`. Waits for permissions so a cold open
 * does not consume the param before rights are known. Clears with replace so
 * back returns to the page the quick action came from.
 */
export const useOpenCreateFromQuery = (open: () => void, isAllowed = true): void => {
  const [createParam, setCreateParam] = useQueryParam<string>('create')
  const permissionsLoaded = usePermissionsLoaded()
  const consumedRef = useRef(false)
  const openRef = useRef(open)
  openRef.current = open

  useEffect(() => {
    if (!createParam) {
      consumedRef.current = false
      return
    }
    if (consumedRef.current || !permissionsLoaded) return

    consumedRef.current = true
    setCreateParam(undefined, { replace: true })
    if (isAllowed) openRef.current()
  }, [createParam, isAllowed, permissionsLoaded, setCreateParam])
}
